import { NodeElement } from './node-element';

export class NodeDeviceCategory extends NodeElement {

}
